// Generated by scripts/sync-work-review-contracts.mjs. Do not edit by hand.
import { z } from 'zod';

const instant = z.string().datetime({ offset: true });
const fields = {
  startedAt: instant,
  endedAt: instant,
  description: z.string().max(4096).nullable(),
  bookingServiceId: z.string().uuid().nullable(),
};
export const completedOwnTimeValuesSchema = z
  .object(fields)
  .strict()
  .refine((v) => Date.parse(v.endedAt) > Date.parse(v.startedAt), {
    message: 'End must follow start',
    path: ['endedAt'],
  });
export const completedOwnTimePatchSchema = z
  .object(fields)
  .partial()
  .strict()
  .refine((v) => Object.keys(v).length > 0, { message: 'At least one changed field is required' });
export const ownTimeCommandSchema = z.discriminatedUnion('action', [
  z
    .object({
      action: z.literal('create'),
      workOrderId: z.string().uuid(),
      values: completedOwnTimeValuesSchema,
    })
    .strict(),
  z
    .object({
      action: z.literal('update'),
      workOrderId: z.string().uuid(),
      entryId: z.string().uuid(),
      patch: completedOwnTimePatchSchema,
    })
    .strict(),
  z
    .object({
      action: z.literal('delete'),
      workOrderId: z.string().uuid(),
      entryId: z.string().uuid(),
    })
    .strict(),
]);
// The displayed fields include canonical server-derived defaults, never model calculations.
export const ownTimeEffectEntrySchema = z
  .object({
    ...fields,
    description: z.string().nullable(),
    durationHours: z.string().nullable(),
    breakHours: z.string(),
    billable: z.boolean(),
    laborRateCents: z.number().finite().nonnegative().nullable(),
  })
  .strict();
export const ownTimeEntrySchema = ownTimeEffectEntrySchema
  .extend({
    id: z.string().uuid(),
    bookingId: z.string().uuid(),
    createdAt: instant,
    updatedAt: instant,
  })
  .strict();
export const ownTimeReviewSchema = z
  .object({
    command: ownTimeCommandSchema,
    revision: z.string().regex(/^sha256:[a-f0-9]{64}$/),
    effects: z
      .object({
        before: ownTimeEffectEntrySchema.nullable(),
        after: ownTimeEffectEntrySchema.nullable(),
      })
      .strict(),
  })
  .strict();
export const reviewedOwnTimeRequestSchema = z
  .object({
    command: ownTimeCommandSchema,
    review: ownTimeReviewSchema,
  })
  .strict();
export const ownTimeOutcomeSchema = z.discriminatedUnion('outcome', [
  z
    .object({
      outcome: z.literal('applied'),
      action: z.enum(['create', 'update', 'delete']),
      workOrderId: z.string().uuid(),
      entryId: z.string().uuid(),
      entry: ownTimeEntrySchema.nullable(),
    })
    .strict(),
  z
    .object({
      outcome: z.literal('stale'),
      code: z.string(),
      error: z.string().optional(),
      message: z.string(),
    })
    .strict(),
  z
    .object({
      outcome: z.literal('refused'),
      code: z.string(),
      error: z.string().optional(),
      message: z.string(),
    })
    .strict(),
  z
    .object({
      outcome: z.literal('unknown'),
      code: z.string(),
      error: z.string().optional(),
      message: z.string(),
    })
    .strict(),
]);
export type OwnTimeCommand = z.infer<typeof ownTimeCommandSchema>;
export type OwnTimeReview = z.infer<typeof ownTimeReviewSchema>;
export type OwnTimeOutcome = z.infer<typeof ownTimeOutcomeSchema>;
export type OwnTimeEntry = z.infer<typeof ownTimeEntrySchema>;
